import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const UserProfile = ({ className = '' }) => {
  const { user, isAuthenticated, isLoading } = useAuth0();

  if (isLoading) {
    return (
      <div className={`flex items-center space-x-2 ${className}`}>
        <div className="w-8 h-8 bg-gray-300 rounded-full animate-pulse"></div>
        <div className="w-20 h-4 bg-gray-300 rounded animate-pulse"></div>
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    return null;
  }

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      {user.picture && (
        <img
          src={user.picture}
          alt={user.name || 'User'}
          className="w-8 h-8 rounded-full object-cover"
        />
      )}
      <div className="flex flex-col">
        <span className="text-sm font-medium text-white">
          {user.name || user.email}
        </span>
        {user.name && user.email && (
          <span className="text-xs text-gray-300">
            {user.email}
          </span>
        )}
      </div>
    </div>
  );
};

export default UserProfile;

